import { Button, RadioGroup } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { CartaoPasso } from './CartaoPasso';
import { EnderecoOficialSection } from './EnderecoOficialSection';
import { temEndereco, type Valores } from './formulario.utils';
import { OpcaoCartao } from './OpcaoCartao';
import { type CtxPasso, TITULO_PASSO } from './passo.types';
import { cadastroEmLinhas } from './ResumoResposta';

/** O endereço do cadastro: "Está certo" ou "Corrigir" (RF-12, RF-16; R9). */
export function PassoCadastro({ ctx }: { ctx: CtxPasso }) {
  const { t } = useTranslation('formulario');
  const { form, cadastro, escolher, avancar } = ctx;
  const { control, register, setValue, getValues, setFocus, watch } = form;
  const escolhaAtual = watch('cadastro');
  const tem = temEndereco(cadastro);

  function selecionar(x: string) {
    escolher('cadastro', x as Valores['cadastro']);
    if (x === 'corrigir') setValue('oficialMarcado', true);
  }
  const escolha = (x: string) => {
    selecionar(x);
    if (x !== 'corrigir') avancar();
  };

  return (
    <CartaoPasso
      titulo={t('cadastro.titulo')}
      onVoltar={ctx.onVoltar}
      onContinuar={
        escolhaAtual === 'corrigir'
          ? ctx.continuar
          : ctx.respondido
            ? () => escolha(escolhaAtual)
            : undefined
      }
    >
      {cadastro && tem && (
        <div className="rounded-md border border-border p-4 text-foreground">
          {cadastroEmLinhas(cadastro).map((l) => (
            <p key={l}>{l}</p>
          ))}
        </div>
      )}
      <RadioGroup
        name="cadastro"
        aria-labelledby={TITULO_PASSO}
        className="grid gap-3 sm:grid-cols-2"
        value={escolhaAtual}
        onValueChange={selecionar}
      >
        {tem && <OpcaoCartao value="certo" label={t('cadastro.certo')} onEscolher={escolha} />}
        <OpcaoCartao value="corrigir" label={t('cadastro.corrigir')} onEscolher={escolha} />
      </RadioGroup>
      {!tem && escolhaAtual !== 'corrigir' && (
        <div>
          <Button type="button" variant="secondary" onClick={() => escolha('pular')}>
            {t('cadastro.pular')}
          </Button>
        </div>
      )}
      {escolhaAtual === 'corrigir' && (
        <EnderecoOficialSection
          control={control}
          register={register}
          setValue={setValue}
          getValues={getValues}
          setFocus={setFocus}
          errors={form.formState.errors}
          paisId={watch('oficial.paisId')}
          estadoId={watch('oficial.estadoId')}
          cidadeId={watch('oficial.cidadeId')}
          cidadeInicial={ctx.cidadeInicial}
          paises={ctx.paises}
          estados={ctx.estados}
          cidades={ctx.cidades}
        />
      )}
    </CartaoPasso>
  );
}
